/**
 * 封装toolbar内不同端独有的svg
 */
import SLIDE_TOGGLE from './slide-toggle.svg';

export default {
    // B端单独所有
    UPLOAD_LOCAL_FILE_ICON: '',
    INSERT_FILE_ICON: '',
    INSERT_WEDRIVE_ICON: '',
    INSERT_WEIXIN_DOC: '',
    // BC端都有
    SLIDE_TOGGLE,
};
